import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Avatar from 'flarum/common/components/Avatar';
import username from 'flarum/common/helpers/username';
import Link from 'flarum/common/components/Link';
import ReactionComponent from '../../common/components/ReactionComponent';
import groupBy from '../utils/groupBy';
import Button from 'flarum/common/components/Button';
export default class ReactionsModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "reactions", []);
    _defineProperty(this, "loading", false);
    _defineProperty(this, "deletingSpecific", {});
    _defineProperty(this, "deletingType", {});
  }
  className() {
    return 'ReactionsModal Modal--small';
  }
  title() {
    return app.translator.trans('fof-reactions.forum.modal.title');
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.load();
  }
  content() {
    if (this.loading) {
      return m("div", {
        className: "Modal-body"
      }, m(LoadingIndicator, null));
    }
    return m("div", {
      className: "Modal-body"
    }, m("ul", {
      className: "ReactionsModal-list"
    }, this.reactions.map(_ref => {
      let {
        reaction,
        users,
        anonymousCount
      } = _ref;
      return this.buildReactionSection(reaction, users, anonymousCount);
    }), !this.reactions.length && m("p", null, app.translator.trans('fof-reactions.forum.modal.no_reactions'))));
  }
  buildReactionSection(reaction, users, anonymousCount) {
    const post = this.attrs.post;

    // The user can delete the reaction if they can delete reactions on the post, or
    // if they can react (i.e. modify their reaction) and it's their own reaction
    const canDeleteReaction = user => post.canDeletePostReactions() || post.canReact() && user === app.session.user;
    return m("div", {
      className: "ReactionsModal-group"
    }, m("legend", null, m(ReactionComponent, {
      reaction: reaction,
      className: 'ReactionModal-reaction'
    }), m("label", {
      className: "ReactionsModal-display"
    }, reaction.display() || reaction.identifier()), post.canDeletePostReactions() && m(Button, {
      icon: "fas fa-minus-circle",
      className: "Button Button--icon Button--link",
      loading: this.deletingType[reaction.id()],
      onclick: this.deletePostReaction.bind(this, false, reaction.id()),
      "aria-label": app.translator.trans('fof-reactions.forum.modal.remove_all_reaction_type', {
        reaction: reaction.display() || reaction.identifier()
      })
    })), m("hr", {
      className: "ReactionsModal-delimiter"
    }), Object.entries(users).map((_ref2, index) => {
      let [postReactionId, user] = _ref2;
      return m("li", {
        key: user.id(),
        "data-post-reaction-id": postReactionId,
        "data-user-id": user.id()
      }, m(Link, {
        className: "ReactionsModal-user",
        href: app.route.user(user)
      }, m(Avatar, {
        user: user,
        loading: "lazy"
      }), username(user)), canDeleteReaction(user) && m(Button, {
        icon: "fas fa-minus-circle",
        className: "Button Button--icon Button--link",
        loading: this.deletingSpecific[postReactionId],
        onclick: this.deletePostReaction.bind(this, postReactionId, reaction.id()),
        "aria-label": app.translator.trans('fof-reactions.forum.modal.remove_user_reaction')
      }));
    }), anonymousCount > 0 && m("li", null, app.translator.trans('fof-reactions.forum.modal.anonymous_count', {
      count: anonymousCount
    })));
  }
  async load() {
    this.loading = true;
    const response = await app.store.find("post_reactions", {
      include: 'user,reaction',
      filter: {
        post: this.attrs.post.id()
      }
    });
    const groupedReactions = groupBy(response, r => r.reactionId());
    const reactions = [];
    for (let reactionId in groupedReactions) {
      const reaction = app.store.getById('reactions', reactionId);
      if (!reaction) {
        continue;
      }
      const users = {};
      let anonymousCount = 0;
      for (let reactionInstance of groupedReactions[reactionId]) {
        const userId = reactionInstance.userId();
        if (userId === null) {
          // Check for null userId
          anonymousCount++;
        } else {
          const user = app.store.getById('users', userId);
          if (user) {
            // Check for null user
            users[reactionInstance.id()] = user;
          }
        }
      }
      reactions.push({
        reaction,
        users,
        anonymousCount
      });
    }
    this.reactions = reactions;
    this.loading = false;
    m.redraw();
  }
  async deletePostReaction(postReactionId, reactionId) {
    const isSpecific = postReactionId !== false;
    const loadingArr = isSpecific ? this.deletingSpecific : this.deletingType;
    const id = isSpecific ? postReactionId : reactionId;
    loadingArr[id] = true;

    // Use the new Flarum 2.0 RESTful endpoints
    const endpoint = isSpecific ? "posts/".concat(this.attrs.post.id(), "/reactions/specific/").concat(id) : "posts/".concat(this.attrs.post.id(), "/reactions/type/").concat(id);
    await app.request({
      method: 'DELETE',
      url: "".concat(app.forum.attribute('apiUrl'), "/").concat(endpoint)
    });

    // Filter out the deleted reaction type
    const reaction = this.reactions.find(reaction => reaction.reaction.id() === reactionId);
    if (isSpecific) {
      // Remove only the specific post_reaction
      const postReaction = app.store.getById('post_reactions', postReactionId);
      if (reaction) {
        delete reaction.users[postReactionId];

        // Remove reaction group if there are no more reactions of this type
        if (!Object.keys(reaction.users).length && !reaction.anonymousCount) {
          this.reactions = this.reactions.filter(r => r.reaction.id() !== reactionId);
        }
      }
      if (postReaction) app.store.remove(postReaction);
      this.attrs.post.reactionCounts()[reactionId]--;
    } else {
      // Remove all reactions of this type
      this.reactions = this.reactions.filter(r => r.reaction.id() !== reactionId);
      if (reaction) {
        for (const postReactionId in reaction.users) {
          const postReaction = app.store.getById('post_reactions', postReactionId);
          if (postReaction) app.store.remove(postReaction);
        }
      }
      this.attrs.post.reactionCounts()[reactionId] = 0;
    }
    delete loadingArr[id];
    m.redraw();
  }
}
flarum.reg.add('fof-reactions', 'forum/components/ReactionsModal', ReactionsModal);